export default __webpack_public_path__ + "static/media/messages-background.f22925db.svg";